<template>
  <button
    type="button"
    @click.prevent="RedeemStart = true"
    class="
      w3-button w3-mobile w3-text-white w3-deep-orange w3-hover-orange
      size14
      px-4
      py-3
      my-2
    "
  >
    <i class="bx bx-log-in-circle"></i>
    {{ label ?? "LIQUIDATE INVESTMENT" }}
  </button>
  <div :class="[RedeemStart ? 'w3-block' : '']" class="w3-modal">
    <div
      class="
        w3-modal-content w3-animate-top
        p-5
        max-width600
        w3-display-container
      "
    >
      <span
        @click.prevent="RedeemStart = false"
        class="w3-text-red w3-display-topright cursor size18 p-4"
      >
        X
      </span>
      <div v-html="SETTINGS._REDEMPTION_DOWNLOAD_DISABLE_MESSAGE"></div>
      <div v-if="SETTINGS._REDEMPTION_DOWNLOAD_FORM" class="mt-4 w3-center">
        <a
          :href="SETTINGS._REDEMPTION_DOWNLOAD_FORM"
          target="_blank"
          class="
            w3-button
            bold
            letter-spacing-1
            w3-red w3-border w3-border-red w3-hover-orange
            px-4
          "
        >
          DOWNLOAD FORM
        </a>
        <div style="clear: both"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { useStore } from "vuex";
import { ref, computed, onBeforeMount } from "vue";
export default {
  props: ["label"],
  setup() {
    const store = useStore();
    const SETTINGS = computed(() => store.state.appSettings);
    const RedeemStart = ref(false);

    onBeforeMount(() => {
      store.dispatch("resetIdleTime");
    });
    return {
      SETTINGS,
      RedeemStart,
    };
  },
};
</script>
